if (!customElements.get('amare-hero-slider')) {
  customElements.define('amare-hero-slider', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.dots = [...this.querySelectorAll('[data-dot]')];
      this.pauseButton = this.querySelector('[data-pause]');
      this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.dot), true)));
      this.pauseButton?.addEventListener('click', () => this.togglePause());
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', (event) => { if (!this.contains(event.relatedTarget)) this.start(); });
      this.reducedMotion.addEventListener('change', () => this.start());
      document.addEventListener('visibilitychange', () => document.hidden ? this.stop() : this.start());
      this.start();
    }
    disconnectedCallback() { this.stop(); }
    show(nextIndex, announce = false) {
      if (!this.slides.length) return;
      this.index = (nextIndex + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, index) => { const active = index === this.index; slide.classList.toggle('is-active', active); slide.setAttribute('aria-hidden', String(!active)); });
      this.dots.forEach((dot, index) => { const active = index === this.index; dot.classList.toggle('is-active', active); dot.setAttribute('aria-current', String(active)); });
      const slide = this.slides[this.index];
      this.querySelector('[data-product-link] [data-model]').textContent = slide.dataset.model;
      this.querySelector('[data-product-link] [data-color]').textContent = slide.dataset.color;
      this.querySelector('[data-product-link] [data-compare-price]').textContent = slide.dataset.comparePrice;
      this.querySelector('[data-product-link] [data-price]').textContent = slide.dataset.price;
      const thumb = this.querySelector('.amare-product-chip__thumb');
      if (thumb) {
        thumb.src = slide.dataset.thumb;
        thumb.alt = `${slide.dataset.model} ${slide.dataset.color}`;
      }
      this.querySelector('[data-product-link]').href = slide.dataset.link;
      if (announce) {
        const status = (this.dataset.labelStatus || '__CURRENT__ / __TOTAL__')
          .replace('__CURRENT__', this.index + 1)
          .replace('__TOTAL__', this.slides.length);
        this.querySelector('[data-status]').textContent = `${slide.dataset.model} ${slide.dataset.color}, ${status}`;
      }
    }
    start() {
      this.stop();
      if (this.dataset.autoplay !== 'true' || this.paused || this.reducedMotion.matches || this.slides.length < 2 || document.hidden) return;
      this.timer = window.setInterval(() => this.show(this.index + 1), Number(this.dataset.interval) || 6000);
    }
    stop() { window.clearInterval(this.timer); }
    togglePause() {
      this.paused = !this.paused;
      this.pauseButton.setAttribute('aria-pressed', String(this.paused));
      this.pauseButton.setAttribute('aria-label', this.paused ? this.dataset.labelStart : this.dataset.labelPause);
      this.paused ? this.stop() : this.start();
    }
  });
}
